// extracted by mini-css-extract-plugin
module.exports = {"footer":"login_modal_footer-module--footer--2aXNs"};